export default __webpack_public_path__ + "static/media/jenkki_logo_white_transparent.234ce87c.svg";